import { constants } from '@bedc/constants';
import { hexColourToNumber } from '@bedc/utils';

const internalFrameColor =
	hexColourToNumber(constants.job.hitlv2.visuals.internalFrameColorHex) ?? 0;

/**
 * Inspect-dialog polygon overlay visuals. Sibling of
 * {@link LengthPolygonRendering}, which the inspect overlay otherwise reuses.
 */
export const InspectPolygonRendering = {
	/**
	 * Frames render almost solid by default (fill level 4) — unlike the length
	 * step. Selection-driven dimming is applied on top by InspectSelectTool.
	 */
	frameFillAlpha: 0.85,

	/** Window openings render indigo on the inspect canvas (doors keep green). */
	windowColor: 0x6166ff,

	/** Internal frames render blue (external frames keep the step pink). */
	internalFrameColor,

	/** Base outline width: frames and unselected opening outlines. */
	outlineWidth: 1.125,

	/**
	 * Clear gap (in multiples of `outlineWidth`) between the frame edge and the
	 * opening outline, per side. Opening cross-section:
	 * `[outline] [gap] [frame width] [gap] [outline]` — outlines grow outwards
	 * from the gap boundary, so the gap survives selection thickening.
	 */
	openingGapFactor: 4,

	/** Selected openings thicken their outline by this factor (outwards). */
	selectedOpeningStrokeFactor: 2.5,

	/**
	 * Selection fill levels (InspectSelectTool). When something is selected the
	 * chosen frame stays at `frameFillAlpha`; every other frame dims to this
	 * "level 1" alpha (lifted to the length step's hover alpha on hover).
	 */
	frameDimmedFillAlpha: 0.1,

	/** Selected opening fill — more opaque than the base, frame still visible under it. */
	selectedOpeningFillAlpha: 0.35,

	/** Padding (px) around a hovered frame/opening's bounding box. */
	hoverBboxPadding: 6,

	/**
	 * Pixi stroke alignment for "grow outwards from the path" — the outline's
	 * inner edge stays on the polygon boundary however thick the stroke gets.
	 */
	outwardStrokeAlignment: 0,
} as const;
